import { Navigate, Route, Routes, useLocation, matchPath } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import Instructor from './Instructor/Index';
import { AuthProvider, useAuth } from './AuthContext';
import EmailVerify from './EmailVerify';
import AcceptInvite from './Instructor/AcceptInvite';
import { AppProvider } from './appprovider';
import Footer from './Footer';
import ResetPassword from './ResetPassword/ResetPassword';
import VerifyOtp from './ResetPassword/VerifyOtp';
import NewPassword from './ResetPassword/NewPassword';
import SuccessPage from './ResetPassword/SuccessPage';
import ErrorPage from './ResetPassword/ErrorPage';
import CourseRegister from './Instructor/course/CourseRegister'
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import SpecialFooter from './Instructor/footer'
import ChatWidget from './ChatWidget/ChatWidget'

function MyRouter() {
  const location = useLocation();
  const { isLoggedIn } = useAuth();
  const isOnInstructorPage = location.pathname.startsWith('/Portal/Instructor');
  const isOnAdminPage = location.pathname.startsWith('/Portal/Admin');
  const isOnLoginPage = location.pathname.startsWith('/login');
  const isCourseRegisterPage = matchPath(
    { path: "/register/:userId" },
    location.pathname
  );
  const isAcceptInvitePage = matchPath(
    { path: "/accept-invite/:token" },
    location.pathname
  );

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return (
    <AppProvider>
      {/* Conditionally render Navbar based on isOnInstructorPage */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/:package" element={<Login />} />
        <Route
          path="/Portal/Instructor/*"
          element={isLoggedIn ? <Instructor /> : <Navigate to="/login" replace />}
        />
        <Route path="/verify-email/:token/:email" element={<EmailVerify />} />
        <Route path="/accept-invite/:token" element={<AcceptInvite />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/register/:userId" element={<CourseRegister />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {isOnInstructorPage || isOnAdminPage ? null : (
        isCourseRegisterPage ? <SpecialFooter /> : <Footer />
      )}
      {/* Floating chat assistant — fixed bottom-right on every page except login
          and the public accept-invite page. */}
      {isOnLoginPage || isAcceptInvitePage ? null : <ChatWidget />}
    </AppProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <MyRouter />
    </AuthProvider>
  );
}

export default App;
